export const validaForcaSenha = password => {
  const regexUppercase = new RegExp(/^(?=.*[A-Z]).+$/);
  const regexLowercase = new RegExp(/^(?=.*[a-z]).+$/);
  const regexStringcase = new RegExp(/(?=.*[A-z]).+$/);
  const regexNumber = new RegExp(/^(?=.*[0-9]).+$/);
  const regexSpecial = new RegExp(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/);

  const length = password.length >= 8;
  const caseText = regexUppercase.test(password) && regexLowercase.test(password);
  const numberText = regexNumber.test(password);
  const stringText = regexStringcase.test(password);
  const charScpecial = regexSpecial.test(password);
  const caseTextCharScpecial = caseText || charScpecial;

  let forcaSenha = 0;

  if (caseTextCharScpecial && numberText && length) {
    forcaSenha = 100;
  } else if (caseTextCharScpecial && length) {
    forcaSenha = 50;
  } else if (length && numberText && stringText) {
    forcaSenha = 50;
  } else if (length) {
    forcaSenha = 15;
  } else if (numberText) {
    forcaSenha = 15;
  } else if (caseTextCharScpecial) {
    forcaSenha = 15;
  } else if (password.length > 0) {
    forcaSenha = 5;
  }

  return forcaSenha;
};

export default validaForcaSenha;
